import { render, staticRenderFns } from "./DisputeResolutionOverview.vue?vue&type=template&id=8d71acf4&scoped=true&"
import script from "./DisputeResolutionOverview.vue?vue&type=script&lang=js&"
export * from "./DisputeResolutionOverview.vue?vue&type=script&lang=js&"
import style0 from "./DisputeResolutionOverview.vue?vue&type=style&index=0&id=8d71acf4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d71acf4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VDataTable,VIcon,VSelect,VTextField})
